import React, { useEffect, useState } from 'react';

import {
  TOUR_SHOWING_STATUS_FAILED,
} from 'common/tourConstants';
import {
  DATA_TABLE_SOURCE_PARTNER_STATS_TOURS,
} from 'common/dataTableConstants';

import {
  actionDataTableLoadItems,
  actionInitializeDataTableState,
} from 'client/helpers/dataTables';

import useDispatch from 'client/hooks/useDispatch';
import safeLocalStorage from 'client/lib/safeLocalStorage';

import SrTourListingFailedModal from 'client/components/SrTourListingFailedModal/SrTourListingFailedModal';

const SrTourListingFailedModalProvider = () => {
  const [tourListing, setTourListing] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    async function loadData() {
      const tourListingIdString = safeLocalStorage.getItem('sunlockBackupCodeShown');
      if (tourListingIdString) {
        const dataTableSettings = {
          itemsPropName: 'tourListings',
          rootViewId:`tourListingId:${tourListingIdString}`,
          dataSource:DATA_TABLE_SOURCE_PARTNER_STATS_TOURS,
          count:1,
          filter: {
            'tourListings.id': parseInt(tourListingIdString, 10),
          },
          customParams: {
            tourStatus: TOUR_SHOWING_STATUS_FAILED,
          },
        };

        dispatch(actionInitializeDataTableState, dataTableSettings);
        const response = await dispatch(actionDataTableLoadItems, dataTableSettings);
        if (response?.items?.length) {
          setTourListing(response.items[0]);
        }
      }
    }
    loadData();
  }, [dispatch]);

  if (!tourListing) {
    return null;
  }

  return (
    <SrTourListingFailedModal
      user={tourListing.user}
      listing={tourListing.listing}
      sunlock={tourListing.sunlock}
      tourListingId={tourListing.id}
      onSubmit={() => {
        setTourListing(null);
      }}
    />
  );
};

SrTourListingFailedModalProvider.displayName = 'SrTourListingFailedModalProvider';

export default SrTourListingFailedModalProvider;
